// Delivery dates for units in the godown.
//
// Mirrors DELIVERY.footnote in data/pricing.js: an order placed Monday to
// Friday arrives the next day (Saturday is a working day), and an order placed
// on Saturday or Sunday arrives on Monday. Public holidays are not modelled;
// the footnote says so wherever a date is promised.
//
// Dates are worked out in the customer's own clock, which for this business is
// India, so there is no time-zone or daylight-saving arithmetic to get wrong.

const WEEKDAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const dayOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);

export function deliveryDateFor(now = new Date()) {
  const today = dayOnly(now);
  const dow = today.getDay(); // 0 Sunday … 6 Saturday
  if (dow === 6) return addDays(today, 2); // Saturday order: Monday
  return addDays(today, 1); // Sunday order lands on Monday too
}

// "Tue 6 Oct"
export const shortDate = (d) => `${WEEKDAY[d.getDay()]} ${d.getDate()} ${MONTH[d.getMonth()]}`;

// "tomorrow, Tue 6 Oct" or "Mon 12 Oct"
export function deliveryLabel(now = new Date()) {
  const d = deliveryDateFor(now);
  const tomorrow = addDays(dayOnly(now), 1);
  return `${d.getTime() === tomorrow.getTime() ? 'tomorrow, ' : ''}${shortDate(d)}`;
}

// The first few days a delivery can be booked, for the preferred-day chips.
// Sundays are skipped.
export function deliveryDays(count = 3, now = new Date()) {
  const out = [];
  let d = deliveryDateFor(now);
  while (out.length < count) {
    if (d.getDay() !== 0) out.push(d);
    d = addDays(d, 1);
  }
  return out;
}
